import type { Instance } from '@nutrient-sdk/viewer';

export const customiseInlineToolbar = (
  instance: Instance,
  toolbarItems: (instance: Instance) => any[]
) => {
  instance.setInlineTextSelectionToolbarItems(() => toolbarItems(instance));
};
